module.exports = __webpack_public_path__ + "img/img_item@2x.c12735db.png";